import { render } from "./product-description.vue?vue&type=template&id=4e16271c"
import script from "./product-description.vue?vue&type=script&lang=js"
export * from "./product-description.vue?vue&type=script&lang=js"

import "./product-description.vue?vue&type=style&index=0&id=4e16271c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__